<template lang="pug">
.providers
    .page-head
        .wrp
        button.btn.green(
            type="button"
            @click="$modal.show('provider-modal')"
        ) Добавить поставщика
    .page-body
        .table
            .thead
                .tr
                    .th #
                    .th Название
                    .th ИНН
                    .th
            .tbody
                .tr(v-for="(provider, index) in providers")
                    .td {{index + 1}}
                    .td {{provider.title}}
                    .td {{provider.inn}}
                    .td
                        .controls
                            .control(@click="editModal(index)")
                                IconPen
    modal.provider-modal(
        name="provider-modal"
        :width="445"
        height="auto"
        @before-close="hideModal"
    )
        .head
            .title {{modalTypes[modalType]}}
            .close(
                @click="$modal.hide('provider-modal')"
            ) Close
                IconClose
        .body
            form(@submit="updateProvider")
                .form-group
                    label Название
                    input(type="text" v-model="providerForm.title")
                
                .form-group
                    label ИНН
                    input(type="text" v-model="providerForm.inn")

                .button-wrapper
                    button.button Сохранить
</template>

<script>
import IconClose from '@/assets/icons/close.svg'
import IconPen from "@/assets/icons/pen.svg"

const formTemplate = {
    id: '',
    title: '',
    inn: '',
}

export default {
    data() {
        return {
            modalType: 0,
            modalTypes: ['Добавление поставщика', 'Редактирование поставщика'],
            providers: [],
            providerForm: formTemplate
        }
    },
    components: {
        IconClose,
        IconPen
	},
    methods: {
        hideModal() {
            this.providerForm = {
                id: '',
                title: '',
                inn: '',
            }
            this.modalType = 0
        },
        editModal(id) {
            this.providerForm = this.providers[id]
            this.$modal.show('provider-modal')
            this.modalType = 1
        },
        updateProvider(e) {
            e.preventDefault();
            var $self = this;
            
            if (this.providerForm.id) {
                this.axios
                .post('/backend/storage/provider/update', this.providerForm)
                .then(resp => {
                    if (resp.data.success) {
                        $self.$modal.hide('provider-modal');
                        $self.getProviders();
                    } else {
                        // TODO Errors
                    }
                })
            } else {
                this.axios
                .post('/backend/storage/provider/create', this.providerForm)
                .then(resp => {
                    if (resp.data.success) {
                        $self.$modal.hide('provider-modal');
                        $self.getProviders();
                    } else {
                        // TODO Errors
                    }
                })
            }
        },
        getProviders() {
            let $self = this;
            this.axios
                .get('/backend/storage/provider/index')
                .then(resp => {
                    if (resp.data.success) {
                        $self.providers = resp.data.data;
                    }
                })
        }
    },
    beforeMount() {
        this.getProviders()
    }
}
</script>

<style lang="scss" scoped>
.providers {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    .provider-modal {
        overflow-y: auto;
        .v--modal {
            .head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 50px;
                padding: 0 17px;
                background: linear-gradient(to top, #b8de76, #ecf58a);
                .title {
                    font-size: 14px;
                }
                .close {
                    display: flex;
                    align-items: center;
                    font-size: 11px;
                    font-weight: 300;
                    cursor: pointer;
                    svg {
                        margin-left: 10px;
                        width: 10px;
                        height: 10px;
                        flex: none;
                    }
                }
            }
            .body {
                padding: 17px;
                form {
                    .form-groups {
                        display: flex;
                        margin: 0 -10px;
                        .form-group {
                            margin: 10px;
                            flex: 1 1 1px;
                        }
                    }
                    .add-ingredient {
                        border-radius: 50%;
                        background: #000;
                        color: #fff;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                        font-size: 20px;
                        margin: 0 auto 30px;
                    }
                    .form-group {
                        margin-bottom: 10px;
                        .group-wrapper {
                            display: flex;
                            align-items: center;
                            .desc {
                                font-size: 14px;
                                padding: 0 10px;
                            }
                        }
                        .input-wrapper {
                            width: 100%;
                            &.small {
                                max-width: 205px;
                            }
                        }
                        label {
                            font-size: 13px;
                            display: block;
                            width: 100%;
                            margin-bottom: 7px;
                        }
                        input,
                        select {
                            border-radius: 3px;
                            border: 1px solid #C4C4C4;
                            height: 40px;
                            width: 100%;
                            padding: 0 15px;
                            font-size: 14px;
                            outline: none;
                            &[disabled] {
                                background: #f9f9f9;
                                border-color: #f9f9f9;
                            }
                            &:focus {
                                border-color: darken(#C4C4C4, 10%)
                            }
                        }
                        textarea {
                            resize: none;
                            border-radius: 3px;
                            padding: 12px 15px;
                            border: 1px solid #C4C4C4;
                            width: 100%;
                            height: 75px;
                            outline: none;
                            &:focus {
                                border-color: darken(#C4C4C4, 10%)
                            }
                        }
                    }
                    .button-wrapper {
                        padding: 15px 0;
                        button {
                            border-radius: 30px;
                            border: none;
                            outline: none;
                            font-size: 14px;
                            width: 150px;
                            height: 40px;
                            display: block;
                            margin: 0 auto;
                            text-align: center;
                            background: linear-gradient(to top, #b8de76, #ecf58a);
                        }
                    }
                }
            }
        }
    }
    .page-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;
        background-color: #fff;
        box-shadow: 0px 0px 11px 0px rgba(226, 227, 231, 0.49);
        position: relative;
        flex: none;
        height: 60px;
        .btn {
            height: 24px;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: #fff;
            padding: 0 15px;
            margin: 0 6px;
            font-size: 12px;
            font-weight: 300;
            cursor: pointer;
            text-decoration: none;
            border: none;
            outline: none;
            &.red {
                background: linear-gradient(to top, #de7676, #f58a8a);
                box-shadow: 0px 3px 6px 0px rgba(134, 156, 238, 0.42);
            }
            &.green {
                background: linear-gradient(to top, #b8de76, #ecf58a);
                box-shadow: 0px 3px 6px 0px rgba(190, 225, 121, 0.42);
                color: #616b46;
            }
        }
    }
    .page-body {
        flex: 1 1 auto;
        overflow-y: auto;
        .table {
            .thead {
                background: #fcfcfc;
                .th {
                    border-bottom: 1px solid #f0f0f0;
                    font-size: 13px;
                    font-weight: 500;
                    padding: 8px 17px;
                }
            }
            .tbody {
                .tr {
                    &:nth-child(even) {
                        background: darken(#fff, .6%);
                    }
                    &:hover {
                        background: darken(#fff, 1%);
                    }
                    .td {
                        border-bottom: 1px solid #f0f0f0;
                        font-size: 13px;
                        font-weight: 300;
                        padding: 13px 17px;
                        vertical-align: middle;
                        .controls {
                            display: flex;
                            justify-content: flex-end;
                            .control {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 30px;
                                height: 30px;
                                cursor: pointer;
                                margin: 0 5px;
                                &:first-child {
                                    svg {
                                        width: 18px;
                                        height: 18px;
                                        fill: #acacac;
                                    }
                                }
                                // &:last-child {
                                //     svg {
                                //         width: 18px;
                                //         height: 18px;
                                //         fill: #e05656;
                                //     }
                                // }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
